export default {
    namespaced: true,
    state: () => ({
        backgroundImageUrl: 'https://static.zaimanhua.com/public/images/web-bg.jpeg'
    }),
    mutations: {
        setBackgroundImageUrl(state, newUrl) {
            state.backgroundImageUrl = newUrl;
        }
    },
    actions: {

    }
}